import React from "react";
import type { SentimentPresentation, SentimentTone } from "./sentimentLogic";

interface SentimentIndicatorProps {
  presentation: SentimentPresentation;
  loading: boolean;
  description: string;
}

const GRAPH_PATHS: Record<SentimentTone, string> = {
  good: "2,18 7,10 12,13 18,5",
  average: "2,13 6,9 10,14 14,8 18,12",
  poor: "2,6 7,14 12,11 18,17",
  idle: "2,12 18,12",
};

function SentimentGraphIcon({ tone }: { tone: SentimentTone }) {
  return (
    <svg
      className="sentiment-indicator__graph"
      viewBox="0 0 20 20"
      aria-hidden="true"
      focusable="false"
    >
      <rect
        className="sentiment-indicator__graph-bg"
        x="1"
        y="1"
        width="18"
        height="18"
        rx="4"
      />
      <polyline
        className="sentiment-indicator__graph-line"
        points={GRAPH_PATHS[tone]}
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function SentimentIndicator({
  presentation,
  loading,
  description,
}: SentimentIndicatorProps) {
  const tone = loading ? "idle" : presentation.tone;
  const label = loading ? "" : presentation.shortLabel;

  return (
    <div
      className={`sentiment-indicator sentiment-indicator--${tone}${
        loading ? " sentiment-indicator--loading" : ""
      }`}
      aria-label={label ? `Customer sentiment: ${label}` : "Customer sentiment"}
    >
      <p className="sentiment-indicator__description">{description}</p>
      <div className="sentiment-indicator__visual">
        <SentimentGraphIcon tone={tone} />
        {label ? (
          <span className="sentiment-indicator__label">{label}</span>
        ) : null}
      </div>
    </div>
  );
}
